import { render, staticRenderFns } from "./MainButton.vue?vue&type=template&id=22bd2b7c&scoped=true"
import script from "./MainButton.vue?vue&type=script&lang=js"
export * from "./MainButton.vue?vue&type=script&lang=js"
import style0 from "./MainButton.vue?vue&type=style&index=0&id=22bd2b7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bd2b7c",
  null
  
)

export default component.exports